/* Hero slider — fade, arrows + dots, optional autoplay. ~0.9KB. */
(function () {
  document.querySelectorAll('[data-hero]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero__slide'));
    if (slides.length < 2) return;

    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    var dotsWrap = root.querySelector('[data-hero-dots]');
    var interval = parseInt(root.getAttribute('data-hero-autoplay'), 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer;

    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (s, idx) {
        var b = document.createElement('button');
        b.className = 'hero__dot' + (idx === 0 ? ' is-active' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Slide ' + (idx + 1));
        b.addEventListener('click', function () { show(idx); reset(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    function reset() {
      if (!interval || reduce) return;
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, interval);
    }

    if (prev) prev.addEventListener('click', function () { show(i - 1); reset(); });
    if (next) next.addEventListener('click', function () { show(i + 1); reset(); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', reset);

    reset();
  });
})();
